export const DEFAULT_OPTION_RELATED_VERITY_INSTITUTE_SETTINGS = {
    liteMode: true,
    allowExtensionPlatform: false,
    allowLockdownPlatform: false,
    allowMobilePlatform: false,
    allowLiveProctoring: false,
    allowLivePopIn: false,
    allowLivePopInPostReview: false,
    allowDemoMode: false,
    allowAiStrictMode: false,
};
export const DEFAULT_OPTION_RELATED_INSTITUTE_SETTINGS = {
    allowStrictMode: false,
    lockdownRequireManagedGuestSession: false,
    disabledProctoringOptions: [],
    flaggedKeywords: [],
    allowQuizAttemptOnChrome: true,
    allowQuizAttemptOnFirefox: false,
    allowQuizAttemptOnSafari: false,
};
export const DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES = {
    proctoringMethod: ["automated", "live", "pop-in", "pop-in-post-review"],
};
const BOOLEAN_OPTION_INFO = {
    defaultValue: false,
    offValues: [false],
    onValues: [true],
};
const ENFORCEMENT_MODE_OPTION_INFO = {
    defaultValue: "off",
    offValues: ["off"],
    onValues: ["normal", "strict"],
};
const LIST_OPTION_INFO = {
    defaultValue: null,
    isList: true,
    offValues: [null, []],
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NON_EMPTY_LIST_OPTION_INFO = {
    defaultValue: null,
    isList: true,
    offValues: [null],
};
export const PROCTORING_OPTION_INFO = {
    enforceLockdown: BOOLEAN_OPTION_INFO,
    enforceMobile: BOOLEAN_OPTION_INFO,
    isExtension: BOOLEAN_OPTION_INFO,
    isLockdown: BOOLEAN_OPTION_INFO,
    isMobile: BOOLEAN_OPTION_INFO,
    isChromeOs: BOOLEAN_OPTION_INFO,
    videoRecordingMode: ENFORCEMENT_MODE_OPTION_INFO,
    audioRecordingMode: ENFORCEMENT_MODE_OPTION_INFO,
    recordScreen: BOOLEAN_OPTION_INFO,
    recordWebTraffic: BOOLEAN_OPTION_INFO,
    detectSidePanel: BOOLEAN_OPTION_INFO,
    oneScreenEnforcementMode: ENFORCEMENT_MODE_OPTION_INFO,
    disableNewTab: BOOLEAN_OPTION_INFO,
    closeOpenTabs: BOOLEAN_OPTION_INFO,
    tabWhiteList: LIST_OPTION_INFO,
    disableClipboardMode: {
        defaultValue: "off",
        offValues: ["off"],
        onValues: ["tab", "system"],
    },
    showRecordingPanel: {
        ...BOOLEAN_OPTION_INFO,
        defaultValue: true,
    },
    idVerification: BOOLEAN_OPTION_INFO,
    idVerificationEnableAi: BOOLEAN_OPTION_INFO,
    faceTrackingMode: ENFORCEMENT_MODE_OPTION_INFO,
    recordClipboard: BOOLEAN_OPTION_INFO,
    recordInput: BOOLEAN_OPTION_INFO,
    excludedWebTrafficRecordingUrls: LIST_OPTION_INFO,
    disableSpellcheck: BOOLEAN_OPTION_INFO,
    disablePrinting: BOOLEAN_OPTION_INFO,
    disableRightClick: BOOLEAN_OPTION_INFO,
    extensionBlockMode: ENFORCEMENT_MODE_OPTION_INFO,
    allowedExtensionsList: LIST_OPTION_INFO,
    tabBlockList: LIST_OPTION_INFO,
    hideOtherWindows: BOOLEAN_OPTION_INFO,
    enableGuidedAccessMode: BOOLEAN_OPTION_INFO,
    restrictHandoffMode: ENFORCEMENT_MODE_OPTION_INFO,
    keyboardShortcutBlockList: LIST_OPTION_INFO,
    disableDownloadFiles: BOOLEAN_OPTION_INFO,
    applicationBlockMode: ENFORCEMENT_MODE_OPTION_INFO,
    blockWindowedApplications: BOOLEAN_OPTION_INFO,
    applicationBlockList: LIST_OPTION_INFO,
    allowedApplicationsList: LIST_OPTION_INFO,
    blockVirtualMachines: BOOLEAN_OPTION_INFO,
    recordApplicationsActivity: BOOLEAN_OPTION_INFO,
    scanRoom: BOOLEAN_OPTION_INFO,
    quietEnvironment: BOOLEAN_OPTION_INFO,
    objectDetectionMode: ENFORCEMENT_MODE_OPTION_INFO,
    enableCalculator: {
        defaultValue: "off",
        offValues: ["off"],
        onValues: ["standard", "scientific"],
    },
    enableWhiteboard: BOOLEAN_OPTION_INFO,
    uploadScratchNotes: BOOLEAN_OPTION_INFO,
    idVerificationMode: ENFORCEMENT_MODE_OPTION_INFO,
    restrictDevices: BOOLEAN_OPTION_INFO,
    audioTranscription: BOOLEAN_OPTION_INFO,
    flaggedKeywords: NON_EMPTY_LIST_OPTION_INFO,
    uploadSignature: BOOLEAN_OPTION_INFO,
    enableGeofence: BOOLEAN_OPTION_INFO,
    geofenceLocations: LIST_OPTION_INFO,
    disableVirtualCamera: BOOLEAN_OPTION_INFO,
};
export const DEFAULT_PROCTORING_OPTION = Object.fromEntries(Object.entries(PROCTORING_OPTION_INFO).map(([option, { defaultValue }]) => [option, defaultValue]));
const LIST_OPTION_KEYS = Object.entries(PROCTORING_OPTION_INFO)
    .filter(([, optionInfo]) => optionInfo.isList)
    .map(([key]) => key);
export const PROCTORING_CONFIGURATION_INFO = {
    isLiveProctored: BOOLEAN_OPTION_INFO,
    isLivePopIn: BOOLEAN_OPTION_INFO,
    enablePostReview: BOOLEAN_OPTION_INFO,
    forceChromeOsManagedGuestSession: BOOLEAN_OPTION_INFO,
};
export const DEFAULT_PROCTORING_CONFIGURATION_OPTIONS = Object.fromEntries(Object.entries(PROCTORING_CONFIGURATION_INFO).map(([option, { defaultValue }]) => [option, defaultValue]));
export const DEFAULT_ENABLED_ASSESSMENT_CONFIGURATION = {
    ...DEFAULT_PROCTORING_CONFIGURATION_OPTIONS,
    enabled: true,
    password: null,
    thirdPartyAssessmentOption: null,
};
export const DEFAULT_ENABLED_ASSESSMENT_CONFIGURATIONS_WITH_PROFILE = {
    ...DEFAULT_ENABLED_ASSESSMENT_CONFIGURATION,
    proctoringOptionProfile: {
        id: -1,
        proctoringOption: DEFAULT_PROCTORING_OPTION,
        type: "assessment",
        name: null,
    },
};
/**
 * Maps a proctoring platform (e.g. `isExtension`) and an editable proctoring option (i.e. `keyboardShortcutBlockList`)
 * to a boolean (indicating whether the proctoring platform does not support a true or non-empty proctoring option value),
 * or an array of unsupported proctoring option values,
 * or an object with an array of unsupported values and a default value (otherwise, `DEFAULT_PROCTORING_OPTION` will be default).
 *
 * The object may have a priority, if platforms have conflicting supported option values, the higher priority gets chosen
 * (e.g. for `hideOtherWindows`, extension only supports `false` with priority 2 and lockdown `true` with 1. Thus `false` is chosen.)
 * By default, supported values have priority 0 and unsupported values have priority 1.
 */
export const PROCTORING_PLATFORM_UNSUPPORTED_OPTIONS = {
    isExtension: {
        recordInput: true,
        recordClipboard: true,
        excludedWebTrafficRecordingUrls: true,
        keyboardShortcutBlockList: true,
        disableClipboardMode: { unsupported: ["system"], default: "tab" },
        enableGuidedAccessMode: true,
        tabBlockList: true,
        disableDownloadFiles: true,
        disableSpellcheck: true,
        blockVirtualMachines: true,
        recordApplicationsActivity: true,
        restrictHandoffMode: ["normal", "strict"],
        applicationBlockMode: ["normal", "strict"],
        blockWindowedApplications: true,
        applicationBlockList: true,
        allowedApplicationsList: true,
        hideOtherWindows: { unsupported: [true], default: false },
        showRecordingPanel: { unsupported: [false], default: true },
    },
    isLockdown: {
        showRecordingPanel: { unsupported: [false], default: true },
        disableRightClick: true,
        extensionBlockMode: ["normal", "strict"],
        allowedExtensionsList: true,
        disablePrinting: true,
        enableGuidedAccessMode: true,
        idVerificationMode: { unsupported: ["strict"], default: "normal" },
        audioTranscription: true,
        flaggedKeywords: true,
        detectSidePanel: true,
        enableGeofence: true,
        geofenceLocations: true,
        disableVirtualCamera: true,
    },
    isMobile: {
        recordInput: true,
        keyboardShortcutBlockList: true,
        tabBlockList: true,
        disableDownloadFiles: true,
        disableSpellcheck: true,
        blockVirtualMachines: true,
        recordApplicationsActivity: true,
        restrictHandoffMode: ["normal", "strict"],
        applicationBlockMode: ["normal", "strict"],
        blockWindowedApplications: true,
        applicationBlockList: true,
        allowedApplicationsList: true,
        idVerificationEnableAi: true,
        showRecordingPanel: { unsupported: [false], default: true },
        enableCalculator: ["standard", "scientific"],
        enableWhiteboard: true,
        disableRightClick: true,
        extensionBlockMode: ["normal", "strict"],
        allowedExtensionsList: true,
        disablePrinting: true,
        faceTrackingMode: ["normal", "strict"],
        objectDetectionMode: ["normal", "strict"],
        idVerificationMode: { unsupported: ["strict"], default: "normal" },
        restrictDevices: true,
        audioTranscription: true,
        flaggedKeywords: true,
        uploadSignature: true,
        detectSidePanel: true,
        enableGeofence: true,
        geofenceLocations: true,
        disableVirtualCamera: true,
        quietEnvironment: true,
    },
};
export function isOptionSupportedForPlatform(proctoringPlatform, option, value) {
    const platformUnsupportedOptions = PROCTORING_PLATFORM_UNSUPPORTED_OPTIONS[proctoringPlatform];
    if (!platformUnsupportedOptions)
        return true; // platform has no unsupported options
    const unsupportedValues = platformUnsupportedOptions[option];
    if (!unsupportedValues)
        return true; // option not listed => fully supported
    if (unsupportedValues) {
        if (typeof unsupportedValues === "boolean") {
            if (unsupportedValues && (value || (Array.isArray(value) && value.length > 0))) {
                return false;
            }
        }
        else if (value === undefined) {
            return false;
        }
        else if (Array.isArray(unsupportedValues)) {
            if (unsupportedValues.includes(value)) {
                return false;
            }
        }
        else if (unsupportedValues.unsupported.includes(value)) {
            return false;
        }
    }
    return true;
}
/**
 * Given an array of proctoring platforms, a proctoring option, and its value,
 * returns a subset of the proctoring platforms array that do not support the
 * given value for the proctoring option
 */
export function getUnsupportingPlatforms(proctoringPlatforms, option, value) {
    const supportingPlatforms = [];
    Object.keys(PROCTORING_PLATFORM_UNSUPPORTED_OPTIONS).forEach((k) => {
        const key = k;
        if (proctoringPlatforms[key] && !isOptionSupportedForPlatform(key, option, value)) {
            supportingPlatforms.push(key);
        }
    });
    return supportingPlatforms;
}
export function getSupportedOptionValueForPlatform(proctoringPlatform, option, value, priority) {
    const unsupportedValues = PROCTORING_PLATFORM_UNSUPPORTED_OPTIONS[proctoringPlatform][option];
    const unsupportedValuesObject = typeof unsupportedValues === "object" && !Array.isArray(unsupportedValues)
        ? { value: unsupportedValues.default, priority: unsupportedValues.priority ?? priority }
        : undefined;
    if (isOptionSupportedForPlatform(proctoringPlatform, option, value)) {
        return { value: value, priority: unsupportedValuesObject?.priority ?? priority };
    }
    else {
        return unsupportedValuesObject ?? { value: DEFAULT_PROCTORING_OPTION[option], priority: priority };
    }
}
/**
 * If the provided proctoring option value is supported for the given proctoring platforms,
 * returns the proctoring option value.
 * If not supported, returns the default property value in `PROCTORING_PLATFORM_UNSUPPORTED_OPTIONS`,
 * or if it does not exist, the corresponding value in `DEFAULT_PROCTORING_OPTION`.
 * Also returns the platform that does not support the given value
 */
export function getSupportedOptionValue(proctoringPlatforms, option, value) {
    const supportedValue = { value: value, priority: 0 };
    let priority = 1;
    Object.keys(PROCTORING_PLATFORM_UNSUPPORTED_OPTIONS).forEach((k) => {
        const key = k;
        if (proctoringPlatforms[key]) {
            const platformValue = getSupportedOptionValueForPlatform(key, option, value, priority);
            if (platformValue.priority > supportedValue.priority) {
                supportedValue.value = platformValue.value;
                supportedValue.priority = platformValue.priority;
                supportedValue.platform = deepEqual(supportedValue.value, value) ? undefined : key;
            }
            priority += 1;
        }
    });
    return { value: supportedValue.value, platform: supportedValue.platform };
}
export function getUnsupportedOptionValues(proctoringPlatforms, option) {
    return new Set(Object.entries(PROCTORING_PLATFORM_UNSUPPORTED_OPTIONS)
        .filter(([platform]) => proctoringPlatforms[platform])
        .flatMap(([_, platformInfo]) => {
        const optionInfo = platformInfo[option];
        if (typeof optionInfo === "boolean") {
            return getPossibleProctoringOptionValues(option);
        }
        if (!optionInfo) {
            return [];
        }
        if (Array.isArray(optionInfo)) {
            return optionInfo;
        }
        return optionInfo?.unsupported ?? [];
    }));
}
export function isOptionSupported(proctoringPlatforms, option, value) {
    const supportedValue = getSupportedOptionValue(proctoringPlatforms, option, value).value;
    return deepEqual(supportedValue, value);
}
export const areSomeOptionsSupported = (options, proctoringOptions) => {
    const option = options ?? {};
    return proctoringOptions.some((key) => {
        const value = option[key];
        if (value === undefined) {
            return true;
        }
        else if (key === "enableCalculator") {
            return isOptionSupported(option, key, "standard") || isOptionSupported(option, key, "scientific");
        }
        else if (typeof value === "string") {
            return isOptionSupported(option, key, "normal") || isOptionSupported(option, key, "strict");
        }
        else if (typeof value === "boolean") {
            return isOptionSupported(option, key, true);
        }
        else {
            return isOptionSupported(option, key, value);
        }
    });
};
const LITE_MODE_DISABLED_OPTIONS = new Set([
    "videoRecordingMode",
    "faceTrackingMode",
    "objectDetectionMode",
    "audioRecordingMode",
    "quietEnvironment",
    "recordScreen",
    "idVerification",
    "idVerificationMode",
    "idVerificationEnableAi",
    "scanRoom",
    "recordInput",
    "recordClipboard",
    "recordWebTraffic",
    "detectSidePanel",
    "excludedWebTrafficRecordingUrls",
    "uploadScratchNotes",
]);
const LITE_MODE_DISABLED_CONFIGURATIONS = new Set([
    "isLiveProctored",
    "isLivePopIn",
    "enablePostReview",
]);
function getPossibleProctoringOptionValues(option) {
    const optionInfo = PROCTORING_OPTION_INFO[option];
    return [...(optionInfo?.offValues ?? []), ...(optionInfo?.onValues ?? [])];
}
export function isProctoringOptionOn(option, value) {
    const optionInfo = PROCTORING_OPTION_INFO[option];
    return optionInfo?.isList ? value && value.length > 0 : (optionInfo?.onValues?.includes(value) ?? false);
}
export function getProctoringOptionDisabledDetails(option, value, proctoringOptions = DEFAULT_PROCTORING_OPTION, verityInstituteSettings = DEFAULT_OPTION_RELATED_VERITY_INSTITUTE_SETTINGS, instituteSettings = DEFAULT_OPTION_RELATED_INSTITUTE_SETTINGS, _enabledConfigurationValues = DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES) {
    const allPossibleValues = getPossibleProctoringOptionValues(option);
    const details = {
        disabledReasons: {},
    };
    // Platforms unsuppoted for selected option
    const unsupportedPlatforms = getUnsupportingPlatforms(proctoringOptions, option, value);
    const platformKeys = Object.keys(PROCTORING_PLATFORM_UNSUPPORTED_OPTIONS);
    // Platforms user seleected
    const selectedPlatforms = platformKeys.filter((key) => proctoringOptions[key]);
    // If ALL selected platforms are unsupported → disable
    const allSelectedUnsupported = selectedPlatforms.length > 0 && unsupportedPlatforms.length === selectedPlatforms.length;
    if (allSelectedUnsupported) {
        const unsupportedValues = getUnsupportedOptionValues(proctoringOptions, option);
        details.disabledReasons.platformUnsupported = {
            allowedValues: allPossibleValues.filter((value) => !unsupportedValues.has(value)),
        };
    }
    if (isProctoringOptionOn(option, value)) {
        if (option === "isExtension" && !verityInstituteSettings.allowExtensionPlatform) {
            details.disabledReasons.platformNotAllowed = {
                allowedValues: PROCTORING_OPTION_INFO[option]?.offValues ?? [],
            };
        }
        else if (option === "isLockdown" && !verityInstituteSettings.allowLockdownPlatform) {
            details.disabledReasons.platformNotAllowed = {
                allowedValues: PROCTORING_OPTION_INFO[option]?.offValues ?? [],
            };
        }
        else if (option === "isMobile" && !verityInstituteSettings.allowMobilePlatform) {
            details.disabledReasons.platformNotAllowed = {
                allowedValues: PROCTORING_OPTION_INFO[option]?.offValues ?? [],
            };
        }
        else if (option === "restrictDevices" && !verityInstituteSettings.allowMobilePlatform) {
            details.disabledReasons.platformNotAllowed = {
                allowedValues: PROCTORING_OPTION_INFO[option]?.offValues ?? [],
            };
        }
        if (verityInstituteSettings.liteMode) {
            if (LITE_MODE_DISABLED_OPTIONS.has(option)) {
                details.disabledReasons.liteMode = {
                    allowedValues: PROCTORING_OPTION_INFO[option]?.offValues ?? [],
                };
            }
            else if (value === "normal") {
                details.disabledReasons.liteMode = {
                    allowedValues: allPossibleValues.filter((v) => v !== "normal"),
                };
            }
        }
        else if (value === "strict") {
            if (!verityInstituteSettings.allowAiStrictMode &&
                (option === "faceTrackingMode" || option === "objectDetectionMode")) {
                details.disabledReasons.aiStrictModeNotAllowed = {
                    allowedValues: allPossibleValues.filter((v) => v !== "strict"),
                };
            }
            if (!instituteSettings.allowStrictMode) {
                details.disabledReasons.instituteDisabledStrictMode = {
                    allowedValues: allPossibleValues.filter((v) => v !== "strict"),
                };
            }
        }
        if (instituteSettings.disabledProctoringOptions.includes(option)) {
            details.disabledReasons.instituteDisabledOption = {
                allowedValues: PROCTORING_OPTION_INFO[option]?.offValues ?? [],
            };
        }
    }
    return {
        ...details,
        disabled: Object.keys(details.disabledReasons).length > 0,
        allowedValues: Object.values(details.disabledReasons).reduce((currValue, { allowedValues }) => {
            const allowedValuesSet = new Set(allowedValues);
            return currValue.filter((value) => allowedValuesSet.has(value));
        }, allPossibleValues),
    };
}
export function isAnyOnValueEnabledForProctoringOption(option, proctoringOptions = DEFAULT_PROCTORING_OPTION, verityInstituteSettings = DEFAULT_OPTION_RELATED_VERITY_INSTITUTE_SETTINGS, instituteSettings = DEFAULT_OPTION_RELATED_INSTITUTE_SETTINGS, enabledConfigurationValues = DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES) {
    const optionInfo = PROCTORING_OPTION_INFO[option];
    const onValues = optionInfo?.isList ? [[""]] : (optionInfo?.onValues ?? []);
    return onValues.some((value) => !getProctoringOptionDisabledDetails(option, value, proctoringOptions, verityInstituteSettings, instituteSettings, enabledConfigurationValues).disabled);
}
function getPossibleProctoringConfigurationValues(option) {
    const optionInfo = PROCTORING_CONFIGURATION_INFO[option];
    return [...(optionInfo.offValues ?? []), ...(optionInfo?.onValues ?? [])];
}
export function isProctoringConfigurationOn(option, value) {
    const optionInfo = PROCTORING_CONFIGURATION_INFO[option];
    return optionInfo.onValues?.includes(value) ?? false;
}
export function proctoringConfigurationToMethodName({ isLiveProctored, isLivePopIn, enablePostReview, }) {
    if (isLiveProctored) {
        return "live";
    }
    else if (isLivePopIn) {
        if (enablePostReview) {
            return "pop-in-post-review";
        }
        else {
            return "pop-in";
        }
    }
    else {
        return "automated";
    }
}
export function proctoringMethodNameToConfiguration(method) {
    switch (method) {
        case "automated":
            return {
                isLiveProctored: false,
                isLivePopIn: false,
                enablePostReview: false,
            };
        case "live":
            return {
                isLiveProctored: true,
                isLivePopIn: false,
                enablePostReview: false,
            };
        case "pop-in":
            return {
                isLiveProctored: false,
                isLivePopIn: true,
                enablePostReview: false,
            };
        case "pop-in-post-review":
            return {
                isLiveProctored: false,
                isLivePopIn: true,
                enablePostReview: true,
            };
    }
}
export function getProctoringConfigurationDisabledDetails(option, value, proctoringConfiguration = DEFAULT_PROCTORING_CONFIGURATION_OPTIONS, verityInstituteSettings = DEFAULT_OPTION_RELATED_VERITY_INSTITUTE_SETTINGS, _instituteSettings = DEFAULT_OPTION_RELATED_INSTITUTE_SETTINGS, enabledConfigurationValues = DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES) {
    const allPossibleValues = getPossibleProctoringConfigurationValues(option);
    const details = {
        disabledReasons: {},
    };
    if (isProctoringConfigurationOn(option, value)) {
        if ((option === "isLivePopIn" && proctoringConfiguration.isLiveProctored) ||
            (option === "enablePostReview" && !proctoringConfiguration.isLivePopIn)) {
            details.disabledReasons.conflict = {
                allowedValues: PROCTORING_CONFIGURATION_INFO[option].offValues ?? [],
            };
        }
        if (option === "isLiveProctored" && !verityInstituteSettings.allowLiveProctoring) {
            details.disabledReasons.methodNotAllowed = {
                allowedValues: PROCTORING_CONFIGURATION_INFO[option].offValues ?? [],
            };
        }
        else if (option === "isLivePopIn" && !verityInstituteSettings.allowLivePopIn) {
            details.disabledReasons.methodNotAllowed = {
                allowedValues: PROCTORING_CONFIGURATION_INFO[option].offValues ?? [],
            };
        }
        else if (option === "enablePostReview" &&
            proctoringConfiguration.isLivePopIn &&
            (!verityInstituteSettings.allowLivePopIn || !verityInstituteSettings.allowLivePopInPostReview)) {
            details.disabledReasons.methodNotAllowed = {
                allowedValues: PROCTORING_CONFIGURATION_INFO[option].offValues ?? [],
            };
        }
        if (verityInstituteSettings.liteMode && LITE_MODE_DISABLED_CONFIGURATIONS.has(option)) {
            details.disabledReasons.liteMode = {
                allowedValues: PROCTORING_CONFIGURATION_INFO[option].offValues ?? [],
            };
        }
    }
    const mergedConfiguration = { ...proctoringConfiguration, [option]: value };
    const method = proctoringConfigurationToMethodName(mergedConfiguration);
    if (!enabledConfigurationValues.proctoringMethod.includes(method)) {
        let enabledMethod;
        if (enabledConfigurationValues.proctoringMethod.includes("live")) {
            enabledMethod = "live";
        }
        else if (enabledConfigurationValues.proctoringMethod.includes("pop-in")) {
            enabledMethod = "pop-in";
        }
        else if (enabledConfigurationValues.proctoringMethod.includes("pop-in-post-review")) {
            enabledMethod = "pop-in-post-review";
        }
        const matchingOption = Object.entries(enabledMethod
            ? proctoringMethodNameToConfiguration(enabledMethod)
            : {
                isLiveProctored: false,
                isLivePopIn: false,
                enablePostReview: false,
            }).find(([key]) => option === key);
        if (matchingOption) {
            const [, enabledValue] = matchingOption;
            details.disabledReasons.editConfigurationRule = {
                allowedValues: allPossibleValues.filter((v) => v !== enabledValue),
            };
        }
    }
    return {
        ...details,
        disabled: Object.keys(details.disabledReasons).length > 0,
        allowedValues: Object.values(details.disabledReasons).reduce((currValue, { allowedValues }) => {
            const allowedValuesSet = new Set(allowedValues);
            return currValue.filter((value) => allowedValuesSet.has(value));
        }, allPossibleValues),
    };
}
export function enforceConfiguration(proctoringConfiguration, proctoringOptions, verityInstituteSettings = DEFAULT_OPTION_RELATED_VERITY_INSTITUTE_SETTINGS, instituteSettings = DEFAULT_OPTION_RELATED_INSTITUTE_SETTINGS, enabledConfigurationValues = DEFAULT_ENABLED_PROCTORING_CONFIGURATION_VALUES) {
    const updatedOptions = { ...proctoringOptions };
    Object.entries(PROCTORING_OPTION_INFO).forEach(([key, optionInfo]) => {
        const option = key;
        const value = proctoringOptions[option];
        if (value !== undefined) {
            const { disabled, allowedValues } = getProctoringOptionDisabledDetails(option, value, proctoringOptions, verityInstituteSettings, instituteSettings, enabledConfigurationValues);
            if (disabled) {
                updatedOptions[option] = (allowedValues[0] ?? optionInfo.defaultValue);
            }
        }
    });
    const updatedConfiguration = { ...proctoringConfiguration };
    Object.entries(PROCTORING_CONFIGURATION_INFO).forEach(([key, optionInfo]) => {
        const option = key;
        const value = proctoringConfiguration[option];
        const { disabled, allowedValues } = getProctoringConfigurationDisabledDetails(option, value, proctoringConfiguration, verityInstituteSettings, instituteSettings, enabledConfigurationValues);
        if (disabled) {
            updatedConfiguration[option] = (allowedValues[0] ?? optionInfo.defaultValue);
        }
    });
    if (!updatedOptions.isExtension && !updatedOptions.isLockdown && !updatedOptions.isMobile) {
        updatedOptions.isExtension = true;
        updatedOptions.isChromeOs = true;
    }
    updatedOptions.enforceMobile = updatedOptions.isMobile;
    updatedOptions.enforceLockdown = updatedOptions.isLockdown && !updatedOptions.isExtension;
    if (updatedOptions.isLockdown &&
        !updatedOptions.isExtension &&
        updatedConfiguration.forceChromeOsManagedGuestSession) {
        updatedOptions.isChromeOs = true;
    }
    return { proctoringConfiguration: updatedConfiguration, proctoringOptions: updatedOptions };
}
export function convertProctoringAssessmentConfigurationV2ToV1(proctoringAssessmentConfigurationV2) {
    const { proctoringOptionProfile, thirdPartyAssessmentOption, ...options } = proctoringAssessmentConfigurationV2;
    return {
        ...options,
        ...proctoringOptionProfile.proctoringOption,
        thirdPartyAssessmentOptions: thirdPartyAssessmentOption,
    };
}
export function convertProctoringAssessmentConfigurationV1ToV2(proctoringAssessmentConfigurationV1) {
    const proctoringOptionKeys = Object.keys(DEFAULT_PROCTORING_OPTION);
    const proctoringAssessmentConfigurationKeys = Object.keys(DEFAULT_ENABLED_ASSESSMENT_CONFIGURATION);
    return Object.keys(proctoringAssessmentConfigurationV1).reduce((obj, curr) => {
        const key = curr;
        if (key === "thirdPartyAssessmentOptions") {
            return {
                ...obj,
                proctoringAssessmentConfiguration: {
                    ...obj.proctoringAssessmentConfiguration,
                    thirdPartyAssessmentOption: proctoringAssessmentConfigurationV1[key],
                },
            };
        }
        else if (proctoringOptionKeys.includes(key)) {
            return {
                ...obj,
                proctoringOption: { ...obj.proctoringOption, [key]: proctoringAssessmentConfigurationV1[key] },
            };
        }
        else if (proctoringAssessmentConfigurationKeys.includes(key)) {
            return {
                ...obj,
                proctoringAssessmentConfiguration: {
                    ...obj.proctoringAssessmentConfiguration,
                    [key]: proctoringAssessmentConfigurationV1[key],
                },
            };
        }
        else {
            return obj;
        }
    }, {
        proctoringAssessmentConfiguration: {},
        proctoringOption: {},
    });
}
export function convertPartialOptionsToNonNullable(proctoringOption, defaultOptions = DEFAULT_PROCTORING_OPTION) {
    return {
        videoRecordingMode: proctoringOption.videoRecordingMode ?? defaultOptions.videoRecordingMode,
        audioRecordingMode: proctoringOption.audioRecordingMode ?? defaultOptions.audioRecordingMode,
        recordScreen: Boolean(proctoringOption.recordScreen),
        recordWebTraffic: Boolean(proctoringOption.recordWebTraffic),
        detectSidePanel: Boolean(proctoringOption.detectSidePanel),
        oneScreenEnforcementMode: proctoringOption.oneScreenEnforcementMode ?? defaultOptions.oneScreenEnforcementMode,
        showRecordingPanel: Boolean(proctoringOption.showRecordingPanel),
        disableNewTab: Boolean(proctoringOption.disableNewTab),
        closeOpenTabs: Boolean(proctoringOption.closeOpenTabs),
        tabWhiteList: Array.isArray(proctoringOption.tabWhiteList)
            ? proctoringOption.tabWhiteList
            : (defaultOptions.tabWhiteList ?? []),
        disableClipboardMode: proctoringOption.disableClipboardMode ?? defaultOptions.disableClipboardMode,
        enableGuidedAccessMode: Boolean(proctoringOption.enableGuidedAccessMode),
        restrictHandoffMode: proctoringOption.restrictHandoffMode ?? defaultOptions.restrictHandoffMode,
        idVerification: Boolean(proctoringOption.idVerification),
        idVerificationEnableAi: Boolean(proctoringOption.idVerificationEnableAi),
        faceTrackingMode: proctoringOption.faceTrackingMode ?? defaultOptions.faceTrackingMode,
        enforceLockdown: Boolean(proctoringOption.enforceLockdown), // TODO: remove
        enforceMobile: Boolean(proctoringOption.enforceMobile), // TODO: remove
        isExtension: Boolean(proctoringOption.isExtension),
        isLockdown: Boolean(proctoringOption.isLockdown),
        isMobile: Boolean(proctoringOption.isMobile),
        isChromeOs: Boolean(proctoringOption.isChromeOs),
        recordClipboard: Boolean(proctoringOption.recordClipboard),
        recordInput: Boolean(proctoringOption.recordInput),
        excludedWebTrafficRecordingUrls: Array.isArray(proctoringOption.excludedWebTrafficRecordingUrls)
            ? proctoringOption.excludedWebTrafficRecordingUrls
            : (defaultOptions.excludedWebTrafficRecordingUrls ?? []),
        disableSpellcheck: Boolean(proctoringOption.disableSpellcheck),
        disablePrinting: Boolean(proctoringOption.disablePrinting),
        disableRightClick: Boolean(proctoringOption.disableRightClick),
        extensionBlockMode: proctoringOption.extensionBlockMode ?? defaultOptions.extensionBlockMode,
        allowedExtensionsList: Array.isArray(proctoringOption.allowedExtensionsList)
            ? proctoringOption.allowedExtensionsList
            : (defaultOptions.allowedExtensionsList ?? []),
        tabBlockList: Array.isArray(proctoringOption.tabBlockList)
            ? proctoringOption.tabBlockList
            : (defaultOptions.tabBlockList ?? []),
        hideOtherWindows: Boolean(proctoringOption.hideOtherWindows),
        disableDownloadFiles: Boolean(proctoringOption.disableDownloadFiles),
        keyboardShortcutBlockList: Array.isArray(proctoringOption.keyboardShortcutBlockList)
            ? proctoringOption.keyboardShortcutBlockList
            : (defaultOptions.keyboardShortcutBlockList ?? []),
        applicationBlockMode: proctoringOption.applicationBlockMode ?? defaultOptions.applicationBlockMode,
        blockWindowedApplications: Boolean(proctoringOption.blockWindowedApplications),
        applicationBlockList: Array.isArray(proctoringOption.applicationBlockList)
            ? proctoringOption.applicationBlockList
            : (defaultOptions.applicationBlockList ?? []),
        allowedApplicationsList: Array.isArray(proctoringOption.allowedApplicationsList)
            ? proctoringOption.allowedApplicationsList
            : (defaultOptions.allowedApplicationsList ?? []),
        blockVirtualMachines: Boolean(proctoringOption.blockVirtualMachines),
        recordApplicationsActivity: Boolean(proctoringOption.recordApplicationsActivity),
        quietEnvironment: Boolean(proctoringOption.quietEnvironment),
        scanRoom: Boolean(proctoringOption.scanRoom),
        objectDetectionMode: proctoringOption.objectDetectionMode ?? defaultOptions.objectDetectionMode,
        enableCalculator: proctoringOption.enableCalculator ?? defaultOptions.enableCalculator,
        enableWhiteboard: proctoringOption.enableWhiteboard ?? defaultOptions.enableWhiteboard,
        uploadScratchNotes: proctoringOption.uploadScratchNotes ?? defaultOptions.uploadScratchNotes,
        idVerificationMode: proctoringOption.idVerificationMode ?? defaultOptions.idVerificationMode,
        restrictDevices: Boolean(proctoringOption.restrictDevices),
        audioTranscription: Boolean(proctoringOption.audioTranscription),
        flaggedKeywords: Array.isArray(proctoringOption.flaggedKeywords)
            ? proctoringOption.flaggedKeywords
            : defaultOptions.flaggedKeywords,
        uploadSignature: Boolean(proctoringOption.uploadSignature),
        enableGeofence: Boolean(proctoringOption.enableGeofence),
        geofenceLocations: Array.isArray(proctoringOption.geofenceLocations)
            ? proctoringOption.geofenceLocations
            : (defaultOptions.geofenceLocations ?? []),
        disableVirtualCamera: Boolean(proctoringOption.disableVirtualCamera),
    };
}
export function equalProctoringOptions(a, b) {
    const ignoredKeys = ["enforceLockdown", "enforceMobile"];
    const keys = Object.keys(DEFAULT_PROCTORING_OPTION).filter((key) => !ignoredKeys.includes(key));
    const filteredA = Object.fromEntries(Object.entries(sanitizeNullArrays(a)).filter((x) => keys.includes(x[0])));
    const filteredB = Object.fromEntries(Object.entries(sanitizeNullArrays(b)).filter((x) => keys.includes(x[0])));
    return deepEqual(filteredA, filteredB);
}
function sanitizeNullArrays(proctoringOption) {
    const sanitizedProctoringOptions = { ...proctoringOption };
    for (const key of LIST_OPTION_KEYS) {
        if (sanitizedProctoringOptions[key] === null) {
            sanitizedProctoringOptions[key] = [];
        }
    }
    return sanitizedProctoringOptions;
}
function deepEqual(x, y) {
    return x && y && typeof x === "object" && typeof x === typeof y
        ? Object.keys(x).length === Object.keys(y).length && Object.keys(x).every((key) => deepEqual(x[key], y[key]))
        : x === y;
}
// TODO: use schema instead
export function isInstituteProfile(profile) {
    return profile.type === "institute" && Boolean(profile.instituteProfile);
}
export function isCourseProfile(profile) {
    return profile.type === "course" && Boolean(profile.courseProfile);
}
export function isUserProfile(profile) {
    return profile.type === "user" && Boolean(profile.userProfile);
}
export function isEnforcedProfile(profile) {
    return isInstituteProfile(profile) && Boolean(profile.instituteProfile?.enforced);
}
//# sourceMappingURL=index.js.map